// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__be0edf7337e4e6c482a1","cls2":"Comments-cls2___13858cc9d75f3976a74 Comments-cls1__be0edf7337e4e6c482a1"};